import { useEffect } from 'react';
import { useHTTP } from 'hooks/useRequest';
import { requestErrors, inputPrompts } from './approvals_group_text';
import { approvalRoles, groupActions } from './approvals_group_reducer';

export const useSubmitGroupRequest = (
  name,
  description,
  admins,
  approvers,
  users,
  createGroupUrl,
  submitGroupRequest,
  approvalGroupDispatch,
) => {
  const createRequestPayload = () => {
    if (!submitGroupRequest) return {};
    const groupAdmins = admins
      .filter(admin => admin.selected)
      .map(admin => ({
        customer_id: admin.customer_id,
        role: approvalRoles.ADMIN,
      }));
    const groupApprovers = approvers
      .filter(approver => approver.selected)
      .map(approver => ({
        customer_id: approver.customer_id,
        role: approvalRoles.APPROVER,
      }));
    const groupUsers = users
      .filter(user => user.selected)
      .map(user => ({
        customer_id: user.customer_id,
        role: approvalRoles.USER,
      }));

    const approvalGroupDetails = {
      approval_group: {
        name,
        description,
        approval_group_users_attributes: [
          ...groupAdmins,
          ...groupApprovers,
          ...groupUsers,
        ],
      },
    };
    return JSON.stringify(approvalGroupDetails);
  };

  const submitGroupConfig = {
    method: 'post',
    url: submitGroupRequest ? createGroupUrl : null,
    data: createRequestPayload(),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };

  // Send POST request with group data
  const { data: groupHttpData, error: groupHttpError } =
    useHTTP(submitGroupConfig);

  useEffect(() => {
    if (groupHttpError === undefined) return;

    // Show error messages if an error is returned
    if (groupHttpError.error.data.errors.includes(requestErrors.blankName)) {
      approvalGroupDispatch({
        type: groupActions.NAME_INVALID,
        payload: inputPrompts.uniqueName,
      });
      approvalGroupDispatch({
        type: groupActions.UPDATE_GROUP_REQUEST,
        payload: false,
      });
    }

    if (
      groupHttpError.error.data.errors.includes(requestErrors.mustHaveAdmin)
    ) {
      approvalGroupDispatch({
        type: groupActions.ADMINS_INVALID,
        payload: inputPrompts.addGroupAdmin,
      });
      approvalGroupDispatch({
        type: groupActions.UPDATE_GROUP_REQUEST,
        payload: false,
      });
    }
  }, [groupHttpError]);

  useEffect(() => {
    if (groupHttpData === undefined) return;

    if (groupHttpData.success) {
      approvalGroupDispatch({ type: groupActions.RESET });
      approvalGroupDispatch({
        type: groupActions.UPDATE_GROUP_REQUEST,
        payload: false,
      });
    }
  }, [groupHttpData]);
};
